export enum BaseURLs {
  API_USER = 'http://localhost:9904/api/',
  API_POST = 'http://localhost:9907/api/',
  API_COMPANY = 'http://localhost:9906/api/',
  API_MESSAGE = 'http://localhost:9903/api/',
  API_POINT = 'http://localhost:9908/api/',
  API_COMMON = 'http://localhost:9905/api/',
  API_HUB = 'http://localhost:9909/EmpactivoHub/',
  API_REPORT = 'http://localhost:9910/api/',
  API_WEBHOOK = 'http://localhost:9914/api/',
}
